import { getIdentifierMapWithoutDivs } from "../sanitizeAnnotations/sanitizeAnnotations";

/**
 * @param {string} identifier - the annotation identifier coming from the View page
 * @param {object} identifierMap contains:
 * - keys that represent the Read page identifier (with the extra div)
 * - values that represent the View page identifier (without the extra div)
 * @returns {string} the Read page identifier
 */
const getReadPageIdentifier = (identifier, identifierMap) => {
  return Object.keys(identifierMap).find(
    (key) => identifierMap[key] === identifier,
  );
};

/**
 * This function updates the start and end identifiers for an annotation in order to account for rendering differences between the Read page and the View page.
 *
 * The Read page adds extraneous divs to the markup in the following scenarios:
 * 1. a div wrapping the entire article body
 * 2. in some articles with inline images:
 * - a div wrapping all content before the image
 * - an empty div immediately following the image
 * - a div wrapping the remaining content (or until the next inline image)
 *
 * Annotations created on the View page will not have these extraneous divs. This function adds them before saving to ensure annotations render correctly on the Read and View pages.
 *
 * @param {object} annotation - data for the annotation that is about to be saved
 * @param {object} rawText - object representing the ProseMirror tree
 * @returns {object} an annotation with updated `start` and `end` properties
 */
const addReadPageIdentifier = (annotation = {}, rawText) => {
  const identifierMap = getIdentifierMapWithoutDivs(rawText);
  const updatedStart = getReadPageIdentifier(annotation.start, identifierMap);
  const updatedEnd = getReadPageIdentifier(annotation.end, identifierMap);

  return { ...annotation, start: updatedStart, end: updatedEnd };
};

export default addReadPageIdentifier;
